// extracted by mini-css-extract-plugin
export var todayMainBanner = "MainBanner_todayMainBanner__tdLSb";
export var todayMainBanner__description = "MainBanner_todayMainBanner__description__5Jw8P";
export var todayMainBanner__imageContainer = "MainBanner_todayMainBanner__imageContainer__DFHf1";
export var todayMainBanner__title = "MainBanner_todayMainBanner__title__PZwSL";
export var todayMainBanner__titleContainer = "MainBanner_todayMainBanner__titleContainer__cnhoQ";